import { Component, OnInit, TemplateRef, Input, ViewChild } from '@angular/core';
import { MailFieldsService } from '../mailfields/mailfields.service';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MailFields } from './mailfields';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { LocalService } from '../../local.service';

@Component({
  selector: 'app-mailfields',
  templateUrl: './mailfields.component.html',
  styleUrls: ['./mailfields.component.css'],
  providers: [MailFieldsService, ToastrService]
})
export class MailfieldsComponent implements OnInit {
  sendMenuId: number;
  sendPageName: string = 'Mail Fields';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;

  modalRef: BsModalRef; closeResult: string; mailfieldsid: number;
  p: number = 1; public searchText: string;
  itemsPerPage: number = 10; _operation: string; 
  userid: number; msg: string; confmsg: string; postresult: boolean;
  key: string = 'mailfields'; //set default
  reverse: boolean = false;
  //formgroup
  mailFieldsForm: FormGroup;
  MailFields: MailFields[];
  mailFields: MailFields;
  submitted = false;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  constructor(private _router: Router, private mailFieldsService: MailFieldsService,
    private modalService: BsModalService,
    private toastr: ToastrService, private dialogService: DialogService, private router: Router,
    private formBuilder: FormBuilder,
    private localService: LocalService) {
    //code to get relavent menu id      
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      localStorage.setItem('MailFields_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('MailFields_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('MailFields_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('MailFields_action');
    } }

 
  ngOnInit() {
    this.mailFieldsForm = this.formBuilder.group(
      {
        mailfieldsid:[''],
        mailfields: ['', Validators.required],
        mailfieldsvalues: ['', Validators.required],
        active: ['', Validators.required]
      });
    this.searchText = '';
    this.LoadExistingMailFieldList();

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }


  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.modalRef.hide();
  }
  
  LoadExistingMailFieldList() {
    this.mailFieldsService.Get().subscribe((res) => {
      if (res != undefined) {
        this.MailFields = res;
      }
    }, error => {
      this.toastr.error('error while getting data');
    });
  }

  get formdata() { return this.mailFieldsForm.controls; }

  PostMailFields(mailField: MailFields) {
    this.submitted = true;
    //if (this.mailFieldsForm.invalid) {
    // // console.log(this.formdata);
    //  //console.log(this.mailFieldsForm.errors);
    //}

    if (((mailField.mailfields.trim() == undefined) || (mailField.mailfields.trim() == '')) ||
      ((mailField.mailfieldsvalues.trim() == undefined) || (mailField.mailfieldsvalues.trim() == ''))) {
      this.toastr.error('Mail fields and Mail fields values should not be empty');
      return;
    }
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');

    //method to add the entered role information
    if (this._operation == 'add') {
      mailField.mailfieldsid = 0;
      mailField.createdby = this.userid;
      this.mailFieldsService.Post(mailField).subscribe((res) => {
        if (res != undefined) {
          if (res.body != 0) {
            this.LoadExistingMailFieldList();
            this.modalRef.hide();
            this.mailFieldsForm.reset();
            this.toastr.success('Data added successfully');
          }
          else { this.toastr.warning('Record already exists'); }
        }
      }, error => {
        this.toastr.error(JSON.stringify(error));
        this.postresult = false;
      });
    }
    else if (this._operation = 'update') {
      this.submitShow = true;
      mailField.modifiedby = this.userid;
      this.mailFieldsService.Put(mailField).subscribe((res) => {
        if (res != undefined) {
          if (res.body != 0) {
            this.LoadExistingMailFieldList();
            this.modalRef.hide();
            this.mailFieldsForm.reset();
            this.toastr.success('Data updated successfully');

          }
          else { this.toastr.warning('Record already exists'); }
        }
      }, error => {
        this.toastr.error(error.error.message); this.postresult = false;
      });
    }
  }

  //method to open the modal popup
  openModal(template: TemplateRef<any>, type, mailFields?: MailFields) {
    this._operation = type
    if (type == 'update') {
      this.mailFieldsForm.controls['mailfieldsid'].setValue(mailFields.mailfieldsid);
      this.mailFieldsForm.controls['mailfields'].setValue(mailFields.mailfields);
      this.mailFieldsForm.controls['mailfieldsvalues'].setValue(mailFields.mailfieldsvalues);
      this.mailFieldsForm.controls['active'].setValue(mailFields.active);
      this.mailFields = mailFields;
    }
    if (type == 'add') {
      this.mailFieldsForm.reset();
      this.mailFieldsForm.controls['active'].setValue(1);
    }
    this.modalRef = this.modalService.show(template, this.config);
    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");
  }

  //method to open the modal popup
  OpenConfirmTemplate(mailFields, template: TemplateRef<any>) {
    if (mailFields.active == 0) {
      this.confmsg = "activate";     
      this.msg = "Record activated successfully";
    }
    else {
      this.confmsg = "deactivate";     
      this.msg = "Record deactivated successfully";
    }
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');

    mailFields.modifiedby = this.userid;
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true

      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          if (mailFields.active == 0)              
            mailFields.active = 1;          
          else            
            mailFields.active = 0;            
          this.mailFieldsService.Delete(mailFields).subscribe((res) => {
            if (res != undefined) {
              if (res.body != 0) {
                this.LoadExistingMailFieldList();
                this.toastr.success(this.msg);
              }
              else { this.toastr.warning('Data not updated...'); }
            }
          }, error => {
            this.toastr.error(error.error.message);
          });
        }
      });

  }

  changed(evt) {
    if (evt.target.checked == false)
      this.mailFieldsForm.value.active = 0;
    else
      this.mailFieldsForm.value.active = 1;
  }   
}
